/*
 * MenuItem
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-08-16 17:20:08
 * @Last Modified by: fan.li@zuolin.com
 * @Last Modified time: 2019-09-17 17:01:22
 */

import * as React from 'react';
import PropTypes from 'prop-types';
import { Menu } from 'antd';
import { MenuIcons } from 'constant';

const MenuItem = Menu.Item;
const SubMenu = Menu.SubMenu;

export default class SideMenuItem extends React.Component {
	render () {
		const { menu, ...rest } = this.props;
		const { name, dtos, isModule, dataType } = menu;
		const hasChildren = dtos && dtos.length > 0;

		if (hasChildren) {
			return (
				<SubMenu
					{...rest}
					key={dataType}
					title={
						<span style={{ display: 'flex', alignItems: 'center' }}>
							<i className={`iconfont icon-${MenuIcons[dataType]}`} style={{ fontSize: 16 }} />
							<span style={{ fontSize: 14, marginLeft: 6 }}>{name}</span>
						</span>
					}
				>
				  {dtos.map(item => {
						const { dataType, name, isModule } = item;
						if (isModule) {
							return (
								<MenuItem key={dataType}>
									<span style={{ fontSize: 14 }}>{name}</span>
								</MenuItem>
							);
						}
						return false;
					})}
				</SubMenu>
			);
		}

		// 不存在二级目录，此时如果一级目录为module，则可跳转
		if (isModule) {
			return (
				<MenuItem key={dataType} {...rest}>
					<span style={{ display: 'flex', alignItems: 'center' }}>
						<i className={`iconfont icon-${MenuIcons[dataType]}`} style={{ fontSize: 16 }} />
						<span style={{ fontSize: 14, marginLeft: 6 }}>{name}</span>
					</span>
				</MenuItem>
			);
		}

		// 无二级目录，且一级目录不是module
		return false;
	}
}

SideMenuItem.propTypes = {
	menu: PropTypes.object.isRequired,  // 一个module
};
